<template>
    <div class="section">
        <div id="support"  ref="support" class="container">
            <div class="md-layout">
                <div class="md-layout-item md-medium-size-66 md-small-size-100 mx-auto">

                    <h1 class="text-center">Техническая поддержка</h1>
                    <h4 class="description text-center">
                        Всем пользователям приложений AkiTorg техническая поддержка предоставляется бесплатно в течении всего срока использования программы.
                    </h4>
                </div>
            </div>

            <div class="md-layout">
<!--                <div class="md-layout-item">-->
                    <div class="md-layout-item md-medium-size-25 md-small-size-100 mx-auto">
                        <info-areas
                                info-horizontal
                                icon-color="info"
                                icon="fas fa-phone"
                        >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                                Наши телефоны
                            </h4>
                            <div
                                 slot="content"
                                    class="description">
                                <p>
                                    Мы готовы проконсультировать вас по телефону.
                                    <br>
                                    Пн-Пт. 9:00-18:00
                                    <br>
                                    Срочные вопросы технической поддержки принимаем круглосуточно.
                                    <br>
                                    <b><a href="tel:8-800-222-02-50">8-800-222-02-50</a></b>
                                    <br>
                                    <b><a href="tel:+7(921)-006-68-95">+7(921)-006-68-95</a></b>
                                </p>
                            </div>
                        </info-areas>
                    </div>

                    <div class="md-layout-item md-medium-size-25 md-small-size-100 mx-auto">
                        <info-areas
                                info-horizontal
                                icon-color="warning"
                                icon="fas fa-envelope"
                        >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                               Электронная почта
                            </h4>
                            <div
                                    slot="content"
                                    class="description">
                                <p>
                                    У нас регистрируется каждое письмо в системе и ему присваивается номер обращения. Поэтому ничего не потеряется. Всегда лучше нам написать.
                                    <br>
                                    <b>support@akitorg.ru</b>
                                </p>
                            </div>
                        </info-areas>
                    </div>

                    <div class="md-layout-item md-medium-size-25 md-small-size-100 mx-auto">
                        <info-areas
                                info-horizontal
                                icon-color="success"
                                icon="fab fa-wikipedia-w"
                        >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                               База знаний
                            </h4>
                            <div
                                    slot="content"
                                    class="description">
                                <p>
                                    Специальный раздел Wiki содержит все необходимые инструкции по работе с нашими мобильными приложениями и интеграционным модулем для 1С.
                                    <br>
                                    <a href="https://wiki.akitorg.ru/" target="_blank"> AkiTorg.WIKI</a>
                                </p>
                            </div>
                        </info-areas>
                    </div>
<!--                </div>-->
<!--                <div class="md-layout-item ">-->
                    <div class="md-layout-item md-medium-size-25 md-small-size-100 mx-auto">
                        <info-areas
                                info-horizontal
                                icon-color="danger"
                                icon="fas fa-file-download"
                        >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                               Файлы для загрузки
                            </h4>
                            <div
                                    slot="content"
                                    class="description">
                                <p>
                                    Все необходимые файлы вы можете загрузить по ссылке
                                </p>
                                <a href="http://wiki.akitorg.ru/index.php?title=%D0%A4%D0%B0%D0%B9%D0%BB%D1%8B_%D0%B4%D0%BB%D1%8F_%D0%B7%D0%B0%D0%B3%D1%80%D1%83%D0%B7%D0%BA%D0%B8" target="_blank">Загрузить</a>
                            </div>
                        </info-areas>
                    </div>
                    <div class="md-layout-item md-medium-size-25 md-small-size-100 mx-auto">
                        <info-areas
                                info-horizontal
                                icon-color="info"
                                icon="fab fa-telegram-plane"
                        >
                            <h4
                                    slot="title"
                                    class="info-title"
                            >
                               Telegram Bot
                            </h4>
                            <div
                                    slot="content"
                                    class="description">
                                <p>
                                    Бот для быстрой поддержки в мессенджере telegram.
                                </p>
                                <a href="https://t.me/AkitorgBot" target="_blank">Перейти в чат</a>
                            </div>
                        </info-areas>
                    </div>
<!--                </div>-->
            </div>

        </div>
    </div>
</template>

<script>
  import InfoAreas from "../InfoAreas";

  export default {
    name: "Support",
    components: {
      InfoAreas
    },
    data() {
      return {

      };
    }
  };
</script>

<style lang="css"></style>
